import React, {Component} from 'react'
import {
  Box,
  Button,
  Heading,
  Textarea,
  VStack,
  Grid,
  GridItem,
  Text,
  Input,
  FormControl,
  FormLabel,
  Checkbox,
  Link
} from '@chakra-ui/react';
import './SuggestieIndienen.css'
import Sidebar from '../Sidebar/Sidebar';
import Navigation from '../../Navigation/Navigation';
import MobileMenu from '../MobileMenu/MobileMenu';
import Footer from '../../../components/Footer/Footer';
import colors from '../../../theme/colors';

class SuggestieIndienen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobileMenuOpen: false,
      privacyConsent: false
    }
  }

  handleOpenMobileMenu = () => {
    this.setState({ isMobileMenuOpen: true })
  }

  handleCloseMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false })
  }

  componentWillUnmount() {
    // Ensure mobile menu is closed when component unmounts
    if (this.state.isMobileMenuOpen) {
      this.setState({ isMobileMenuOpen: false })
    }
  }
  render () {
    return (
      <>
        <Grid templateColumns="repeat(24, 1fr)" bg="gray.50">
        {/* sidebar */}
        <GridItem
          as="aside"
          colSpan={{ base: 0, md: 4, lg: 3 }} 
          display={{ base: "none", md: "block" }}
          bg="gray.50"
          minHeight={{ lg: '100vh' }}
          p={0}
        >
        <Sidebar
        getFeed = {this.props.getFeed}
        onRouteChange = {this.props.onRouteChange}
        userVersion = {this.props.state.userVersion}
        resetSuggestionsPage = {this.props.resetSuggestionsPage}
        onLogout = {this.props.onLogout}
        />
        </GridItem>
        <GridItem
        as="main"
        colSpan={{ base: 24, md: 20, lg: 21 }}
        p="10px"
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        >
        <Navigation
        state = {this.props.state}
        onRouteChange = {this.props.onRouteChange}
        getFeed = {this.props.getFeed}
        onVersionChange = {this.props.onVersionChange}
        onLogout = {this.props.onLogout}
        onOpenFeedback = {this.props.onOpenFeedback}
        onOpenMobileMenu = {this.handleOpenMobileMenu}
        />

        <Box p="40px" flex="1" display="flex" justifyContent="center" alignItems="center">
          <Box maxW="800px" w="100%">
            <VStack spacing={6} align="stretch">
              <Heading as="h2" size="lg" textAlign="center" color="gray.600">
                Indienen
              </Heading>

              <Text color="gray.500" textAlign="center">
                Deel uw ideeën, zorgen en suggesties voor een betere samenleving
              </Text>

              {/* Show email field for guest users */}
              {this.props.state.userVersion === 'guest' && (
                <FormControl isRequired>
                  <FormLabel>Email</FormLabel>
                  <Input
                    type="email"
                    placeholder="uw@email.com"
                    value={this.props.state.email || ''}
                    onChange={(e) => this.props.onEmailChange(e.target.value)}
                    bg="white"
                    border="2px solid"
                    borderColor="gray.200"
                    _focus={{
                      borderColor: "blue.400"
                    }}
                  />
                </FormControl>
              )}

              <Textarea
                placeholder="Typ hier uw suggestie..."
                size="lg"
                minH="300px"
                resize="vertical"
                value={this.props.state.suggestionText || ''}
                onChange={(e) => this.props.onSuggestionTextChange(e.target.value)}
                bg="white"
                border="2px solid"
                borderColor="gray.200"
                _focus={{
                  borderColor: "blue.400"
                }}
              />

              {/* Privacy Consent Checkbox - Only for guest users */}
              {this.props.state.userVersion === 'guest' && (
                <FormControl>
                  <Checkbox
                    isChecked={this.state.privacyConsent}
                    onChange={(e) => this.setState({ privacyConsent: e.target.checked })}
                    colorScheme="brand"
                  >
                    <Text fontSize="sm" color="gray.600">
                      Ik ga akkoord met het{' '}
                      <Link
                        color="blue.500"
                        onClick={() => this.props.onRouteChange('privacyPolicy')}
                        textDecoration="underline"
                      >
                        privacybeleid
                      </Link>
                      {' '}en de{' '}
                      <Link
                        color="blue.500"
                        onClick={() => this.props.onRouteChange('termsOfService')}
                        textDecoration="underline"
                      >
                        algemene voorwaarden
                      </Link>
                      {' '}en begrijp dat mijn e-mailadres en suggestie kunnen worden verwerkt om contact met mij op te nemen.
                    </Text>
                  </Checkbox>
                </FormControl>
              )}

              {/* AI Consent Checkbox - Only for guest users */}
              {this.props.state.userVersion === 'guest' && (
                <Box bg="gray.50" p={4} borderRadius="md" borderLeft="4px solid" borderColor="gray.400">
                  <FormControl>
                    <Checkbox
                      isChecked={this.props.state.allowAiSummarization || false}
                      onChange={(e) => this.props.onAiConsentChange(e.target.checked)}
                      colorScheme="brand"
                    >
                      <Text fontSize="sm" fontWeight="600" color="gray.700">
                        Ik geef toestemming om mijn suggestie te gebruiken voor AI-samenvattingen{' '}
                        <Text as="span" fontWeight="400" color="gray.600">
                          (optioneel)
                        </Text>
                      </Text>
                    </Checkbox>
                    <Text fontSize="xs" color="gray.600" mt={2} ml={6}>
                      AI helpt vertegenwoordigers om voorstellen van inwoners samen te vatten en patronen te herkennen.
                    Je identiteit blijft beschermd - alleen de inhoud van jouw suggestie wordt gebruikt.
                    </Text>
                  </FormControl>
                </Box>
              )}

              <Box textAlign="right">
                <Text fontSize="sm" color="gray.400" mb={4}>
                  {(this.props.state.suggestionText || '').length} karakters
                </Text>

                <Button
                  px={8}
                  py={4}
                  fontSize="lg"
                  bg={colors.primary.main}
                  color="white"
                  boxShadow={`0px 1px 25px -5px rgba(177, 24, 24, 0.48), 0 10px 10px -5px rgba(177, 24, 24, 0.43)`}
                  _hover={{
                    bg: colors.primary.dark,
                  }}
                  _focus={{
                    bg: colors.primary.dark,
                  }}
                  disabled={
                    !this.props.state.suggestionText ||
                    this.props.state.suggestionText.trim().length === 0 ||
                    (this.props.state.userVersion === 'guest' && (!this.props.state.email || this.props.state.email.trim().length === 0)) ||
                    (this.props.state.userVersion === 'guest' && !this.state.privacyConsent)
                  }
                  onClick={this.props.onSubmitSuggestion}
                  isLoading={this.props.state.isSubmittingSuggestion}
                  loadingText="Indienen..."
                >
                  Suggestie Indienen
                </Button>
              </Box>
            </VStack>
          </Box>
        </Box>
        <Footer onRouteChange={this.props.onRouteChange} />

        </GridItem>
        </Grid>
      
        {/* Mobile Menu Drawer */}
        <MobileMenu
          isOpen={this.state.isMobileMenuOpen}
          onClose={this.handleCloseMobileMenu}
          onRouteChange={this.props.onRouteChange}
          userVersion={this.props.state?.userVersion || 'burger'}
          resetSuggestionsPage={this.props.resetSuggestionsPage}
          onLogout={this.props.onLogout}
        />
      </>
    )
  }
}

export default SuggestieIndienen